"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationAsset',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        activate: '启用',
        block: '封禁',
        restore: '解封',
        delete: '删除'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationAssetListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('文件名', '新素材').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationAssetSaveApi)({
          assetType: 'image',
          fileName: value || '门店照片.jpg',
          fileUrl: 'https://example.com/store-photo.jpg',
          mimeType: 'image/jpeg',
          fileSize: 102400,
          copyrightType: 'original'
        }).then(function () {
          _this2.$message.success('素材已创建');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationAssetActionApi)(row.asset.id, {
          action: action
        }).then(function () {
          _this3.$message.success('素材已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};